import {
  createObjectValidator,
  validateNumber,
  validateString,
  validateUuidV4
} from "../../../../packages/validator/validator.js";

/**
 * Contains data for showing in the entries table.
 */
export type EntrySummary = {
  id: string;
  date: string;
  title: string;
  /**
   * Number of files on this entry.
   */
  fileCount: number;
  /**
   * Sum of incomes under this entry.
   */
  totalIncome: number;
  /**
   * Sum of expenses under this entry.
   */
  totalExpense: number;
  /**
   * Total change in assets under this entry.
   */
  changeAssets: number;
  /**
   * Total change in liabilities under this entry.
   */
  changeLiabilities: number;
  /**
   * Total change in cash under this entry.
   */
  changeCash: number;
};

export const validateEntrySummary = createObjectValidator<EntrySummary>("EntrySummary", {
  id: validateUuidV4,
  date: validateString,
  title: validateString,
  fileCount: validateNumber,
  totalIncome: validateNumber,
  totalExpense: validateNumber,
  changeAssets: validateNumber,
  changeLiabilities: validateNumber,
  changeCash: validateNumber
});
